import React, { useState, useEffect, useMemo, useCallback } from "react";
import dynamic from "next/dynamic";
import Locale from "@/app/locales";
import { useCurrentLocale } from "@/app/lib/LocaleProvider";
import { useRouter } from "next/navigation";
import styles from "./MobileFooterTabBar.module.scss";
import { throttle } from "@/app/utils";
import Image from "next/image";
import { Popup } from "antd-mobile";
import { Toast } from "@douyinfe/semi-ui";
import { isHandyApp } from "@/app/utils/device";

interface FooterType {
  type: string;
  title: string;
  icon: string;
  iconActive: string;
  template: React.ComponentType<any>;
}

interface FooterTabBarProps {
  // lng: string;
  techAIFlag?: boolean;
  // contentHeight: number;
  techImFlag?: boolean;
  countryCode?: string;
}

const MobileFooterTabBar: React.FC<FooterTabBarProps> = ({
  techAIFlag,
}: FooterTabBarProps) => {
  const [contentHeight, setContentHeight] = useState(0);
  const language = useCurrentLocale();
  const [popupVisible, setPopupVisible] = useState(false);
  // const openAIMode = useAppSelector((state: RootState) => state.openAIReducer.openAIMode);
  const [typeList, setTypeList] = useState<FooterType[]>([]);
  const [activeType, setActiveType] = useState("");
  const router = useRouter();

  const requireTypeOptions = (): FooterType[] => [
    {
      type: "IMLink",
      title: Locale.footerTabBar.IMService,
      icon: "/images/im-service.svg",
      iconActive: "",
      template: () => <></>,
    },
    {
      type: "GeneralInquiries",
      title: Locale.footerTabBar.generalInquiries,
      icon: "/images/question-type.svg",
      iconActive: "/images/question-type-active2.svg",
      template: dynamic(
        () =>
          import(
            "@/app/components/robot/components/sidebarContent/fragments/categoryList"
          ),
      ),
    },
    {
      type: "SelfService",
      title: Locale.footerTabBar.selfService,
      icon: "/images/question-type.svg",
      iconActive: "/images/question-type-active2.svg",
      // TODO: 这个组件里引用了requireRobotAIKeywordList from handyApp
      template: dynamic(
        () => import("@/app/components/robot/components/AssociateButtonList"),
      ),
    },
    {
      type: "PopularTags",
      title: Locale.footerTabBar.popularTags,
      icon: "/images/popular-tags.svg",
      iconActive: "/images/popular-tags-active2.svg",
      template: dynamic(
        () => import("@/app/components/robot/components/AssociateButtonList"),
      ),
    },
  ];
  const onCloseClick = () => {
    setActiveType("");
    setPopupVisible(false);
  };
  const renderSheetContent = () => {
    if (!activeType) return "";
    const currentItem = typeList.find((item) => item.type === activeType);
    if (!currentItem) return "";
    const Template = currentItem.template;
    return (
      <Template
        className={styles.templateWrapper}
        lng={language}
        techAIFlag={techAIFlag}
        type={currentItem.type}
        onClickCallback={onCloseClick}
      />
    );
  };
  useEffect(() => {
    const typeOptions = requireTypeOptions();
    let allowType = "";
    // handy中只显示自助服务
    if (techAIFlag) {
      allowType = "SelfService";
      // allowType = "SelfService,PopularTags";
    } else {
      // if (openAIMode) {
      //   allowType = 'GeneralInquiries,PopularTags';
      // } else {
      allowType = "GeneralInquiries,PopularTags";
      // }
    }
    setTypeList(
      typeOptions.filter((item) => allowType.indexOf(item.type) > -1),
    );
  }, [techAIFlag, language]);

  const throttleClick = useMemo(
    () =>
      throttle(async (item: FooterType) => {
        if (item.type === "IMLink") {
          if (!isHandyApp()) {
            Toast.warning(Locale.footerTabBar.inAppTips);
            return;
          }

          const { hostname: supportRobotOrigin } = location;
          // TODO: 直接出现问题类型选择
        } else {
          if (item.type === activeType) {
            setPopupVisible(false);
            setActiveType("");
            return;
          }
          if (activeType) {
            setPopupVisible(() => false);
            setTimeout(() => {
              setPopupVisible(true);
              setActiveType(item.type);
            }, 300);
            return;
          }
          setActiveType(item.type);
          setPopupVisible(true);
        }
      }, 300),
    [activeType, language, router],
  );
  const onTabBarClick = useCallback(
    (item: FooterType) => throttleClick(item),
    [throttleClick],
  );

  // useImperativeHandle(
  //   ref,
  //   () => ({
  //     closeTabBarPopup: () => {
  //       setActiveType('');
  //       setPopupVisible(false);
  //     },
  //   }),
  //   [],
  // );
  return (
    <div>
      <div className={styles.footerTabBarWrapper}>
        {typeList.map((item) => (
          <div
            key={item.type}
            className={`${styles.tabBarItem} ${popupVisible && activeType === item.type ? styles.active : ""}`}
            onClick={() => onTabBarClick(item)}
          >
            <img
              src={
                popupVisible && item.type === activeType
                  ? item.iconActive
                  : item.icon
              }
            />
            <span className={styles.desc}>{item.title}</span>
          </div>
        ))}
      </div>

      <Popup
        visible={popupVisible}
        onMaskClick={onCloseClick}
        className={styles.tabBarPopup}
        maskClassName={styles.tabBarActionSheetMask}
        bodyClassName={styles.tabBarActionSheetBody}
      >
        <div className={styles.popupContent}>
          <div className={styles.expandWrapper}>
            <Image
              className={styles.expend}
              onClick={onCloseClick}
              src="/images/expand-black.svg"
              height={20}
              width={20}
              alt=""
            />
          </div>
          {renderSheetContent()}
        </div>
      </Popup>
    </div>
  );
};

export default MobileFooterTabBar;
